const preposition = {
    courier: 'To:',
    pickup: 'From:',
};

const orderAnalyticsMapper = require('./analytics/order-analytics-mapper-gtm'), _ = require('lodash'), $ = require('jquery');
const orderAnalyticsDtmMapper = require('./analytics/order-analytics-mapper-dtm');

class CheckoutConfirmationController {
    constructor($scope, gtm, shopperService, settingsService, analytics, deploymentSwitchService, packagingPreferenceService, settings) {
        this.orderId = this.confirmation.Order.OrderId;
        this.orderStatus = this.confirmation.Order.OrderStatus;
        this.orderCancelled = this.orderStatus === 'Cancelled';
        this.$scope = $scope;
        this.gtm = gtm;
        this.shopperService = shopperService;
        this.settingsService = settingsService;
        this.analytics = analytics;
        this.deploymentSwitchService = deploymentSwitchService;
        this.packagingPreferenceService = packagingPreferenceService;
        this.settings = settings;
    }

    $onInit() {
        const deliveryMethod = this.confirmation.Order.DeliveryMethod.toLowerCase();
        this.completedOrder = this.confirmation.Order;

        this.orderMethodMessage =
            deliveryMethod === 'courier' ? this.settings.checkoutConfirmation.deliveryMethodMessageDeliver : this.settings.checkoutConfirmation.deliveryMethodMessagePickup;

        this.orderMethodPreposition = preposition[deliveryMethod];
        this.orderRecipient = this.getRecipientText(deliveryMethod);

        this.settingsService.getSettingValue('EverydayRewards', 'CardName').then((setting) => {
            this.RewardsCardName = setting;
        });
        this.settingsService.getSettingValue('Checkout', 'EVoucherDisplayName').then((setting) => {
            this.EVoucherDisplayName = setting;
        });

        if (this.confirmation.Order) {
            const orderWithoutDetail = _.cloneDeep(this.confirmation.Order);
            delete orderWithoutDetail.PaymentBreakdown;
            const analyticsObj = {
                data: {
                    order: orderWithoutDetail,
                    orderDetails: this.confirmation.Order,
                    shopper: this.shopperService,
                    shopperDetails: undefined,
                    rewardsPointsConversionBase: this.settingsService.settings.loyalty.rewardsConversionBase,
                },
            };
            if (!this.confirmation.IsPushedToGtm) {
                analyticsObj.gtmMapperFn = orderAnalyticsMapper;
            }
            if (!this.confirmation.IsPushedToDtm) {
                analyticsObj.dtmMapperFn = orderAnalyticsDtmMapper;
            }
            this.analytics.push(analyticsObj);
            if (this.deploymentSwitchService.wos6359 && this.settings.checkout.enablePackagingPreference) {
                this.packagingPreferenceService.pushToAnalytics(orderWithoutDetail.PackagingPreference);
            }
        }

        this.settingsService.getSettingValue('SiteCensus', 'ResponsysTrackingPixel').then((urlSetting) => {
            if (urlSetting) {
                this.addResponsysTrackingPixelToBody(this.createSourceString(urlSetting));
            }
        });
    }

    getRecipientText(deliveryMethod) {
        return deliveryMethod === 'courier'
            ? `${this.completedOrder.FirstName} ${this.completedOrder.LastName}`
            : this.completedOrder.PickUpStoreName;
    }

    stringFormat(string, args) {
        _.forEach(args, (value, key) => { string = string.replace(`{${key}}`, value); });
        return string;
    }

    calculateQuantity(products) {
        return _.reduce(products, (sum, product) => sum + product.Quantity, 0);
    }

    createSourceString(urlSetting) {
        return this.stringFormat(urlSetting, {
            OrderID: this.completedOrder.OrderId,
            OrderTotal: this.completedOrder.TotalIncludingGst,
            OrderQty: this.calculateQuantity(this.completedOrder.Products),
            ShopperID: this.shopperService.Id,
        });
    }

    addResponsysTrackingPixelToBody(sourceString) {
        $(`<img id="responsysTrackingPixel" src="${sourceString}">`).appendTo('body');

        this.$scope.$on('$destroy', () => {
            $('#responsysTrackingPixel').remove();
        });
    }
}

const checkoutConfirmationControllerComponentDefinition = {
    bindings: {
        confirmation: '=',
        showSaveCard: '=saveCard',
    },
    controller: ['$scope', 'GtmService', 'ShopperService', 'SettingsService', 'AnalyticsService', 'DeploymentSwitchService', 'PackagingPreferenceService', 'Settings', CheckoutConfirmationController],
    template: require('./checkoutconfirmation.component.html').trim(),
};

module.exports = {
    CheckoutConfirmationController,
    checkoutConfirmationControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/confirmation/checkoutconfirmation.component.js